import React from "react";
import { Button, Card, Col, notification, Row, Space } from "antd";
import FilterPills from "../../widgets/FilterPills";
import Markdown from "react-markdown";
import rehypeRaw from "rehype-raw";
import remarkGfm from "remark-gfm";
import PostsApi from '../../api-services/posts-api.service';
import Headline from "./Headline";
import HomeLink from "../../widgets/HomeLink";
import { Post } from "../../interfaces/post.interface";
import { format } from "date-fns";
const { Meta } = Card;

const bannerPath = '/iceholidays-assets/images/blog.png';
const _breadcrumbs = [
  { title: <HomeLink/>},
  { title: 'Blog' }
] 

const types = [ {type: "news_and_events", label: "News"},{type: "blog", label:"Blogs"} ];


export default class BlogPage extends React.Component {
  postsApi = new PostsApi;

  state = {
    blogs: [],
    breadcrumbs: _breadcrumbs,
    searchParamsObj: {type: "", year: "", months: null},
  }

  componentDidMount() {
    this.getPosts();
  }
  

  setFilter = (selectedFilter) => {
    const {breadcrumbs} = this.state;
    breadcrumbs[2] = {title: this.searchParamsToText()};

    const allHasValues = Object.entries(selectedFilter).every(o => o[1] != "" && o[1] != null);
    if(allHasValues){
      breadcrumbs[1] = {title: <span>Search results</span>};
    }
    this.setState({searchParamsObj: selectedFilter, breadcrumbs})
    this.getPosts();
  }


  getPosts(){
    const {type, ...otherSearchParams} = this.state.searchParamsObj;
    this.postsApi.getPosts(type, 1, otherSearchParams)
      .then(({posts}) => {
        this.setState({blogs: posts})
      })
      .catch(error => {
        notification.error({ message: 'An error occured while loading blogs.'});
      });
  }


  searchParamsToText() {
    var {type, year, months} = this.state.searchParamsObj;
    var month;
    if(months != null) month = format(new Date(months[0]), 'MMM')
    const monthYear = (month || year) && `${month} ${year}`;
    const formatType = types.find(t => t.type == type)?.label;
    const text = [formatType, monthYear].filter(val => val).join(", ");
    return <span>{ text } </span>
  }

  render(){
    const {blogs, breadcrumbs, searchParamsObj} = this.state;
    return (
      <div id="blog-page">
        <Headline bannerImage={bannerPath} breadcrumbs={breadcrumbs} title="Blog"/>

        <div id="blog-page_body">
          <Space size={12} direction="vertical">
          <FilterPills items={types} bindValue="type" allOption={true} initialValue={searchParamsObj} disableMonths={false} selectFilter={(selected)=>this.setFilter(selected)}></FilterPills>
          </Space>

          <div id="blogs">
            <Row wrap gutter={20}>
              {
                blogs.map((blog:Post) => (
                  <Col key={blog.id} span={8}>
                    <Card cover={<img alt={blog.title} src={blog.thumbnail} />}>
                        <Meta title={blog.title} description={
                          <>
                            {/* <span>{blog.info}</span> */}
                            <div className="preview-content">
                              <Markdown remarkPlugins={[remarkGfm]} rehypePlugins={[rehypeRaw]}>{blog.content}</Markdown>
                            </div>

                            <Button className="view-blog" href={`/web/blog/${blog.id}`} type="link" color="primary" variant="outlined" block>阅读更多</Button>
                          </>
                        } />
                    </Card>
                  </Col>
                ))
              }
            </Row>
          </div>
        </div>
      </div>
    )
  }

}